import styled from "@emotion/styled";

export const TableLoading = styled.div`
  min-height: 350px;
  position: relative;
  padding: 50px;
  background: #fff;
`;
